module.exports = __webpack_public_path__ + "assets/img/12_108_big.4982dd4b.jpg";